import * as Sentry from '@sentry/react';

import api from '../api/axios';
import authorizationHeader from '../api/token';

// GET Obtiene una estructura anatómica por su UID de Sketchfab desde el backend
export const getAnatomicalStructureBySketchfabUid = async sketchfabUid => {
  const token = await authorizationHeader();
  const response = await api
    .get(`/anatomical-structure/${sketchfabUid}`, {
      headers: token,
    })
    .then(res => res)
    .catch(err => {
      Sentry.captureException(err);
      if (err?.response?.data) {
        Sentry.captureMessage(err.response.data);
      }
      throw err;
    });
  return response.data;
};

// POST Crea un vector en Pinecone con los datos de una estructura anatómica
export const upsertAnatomicalStructureVectorToPinecone = async data => {
  const token = await authorizationHeader();
  const response = await api
    .post('/anatomical-structure/upsert-vector', data, {
      headers: token,
    })
    .then(res => res)
    .catch(err => {
      Sentry.captureException(err);
      if (err?.response?.data) {
        Sentry.captureMessage(err.response.data);
      }
      throw err;
    });
  return response;
};

// PATCH Actualiza los datos de una estructura anatómica (backend)
export const updateAnatomicalStructure = async (sketchfabUid, data) => {
  const token = await authorizationHeader();
  const response = await api
    .patch(`/anatomical-structure/${sketchfabUid}`, data, {
      headers: token,
    })
    .then(res => res)
    .catch(err => {
      Sentry.captureException(err);
      if (err?.response?.data) {
        Sentry.captureMessage(err.response.data);
      }
      throw err;
    });
  return response;
};
